import * as types from './index';

export const clearAction = (data) => {
    return {
    type: types.CLEAR,
    data
    }
};

export const masterLocationListAction = (data) => {
    return {
    type: types.MASTER_LOCATION_LIST,
    data
    }
};

export const currencyListAction = (data) => {
    return {
    type: types.LIST_CURRENCY,
    data
    }
};

export const primaryUsersListAction = (data) => {
    return {
    type: types.LIST_PRMY_CNCT,
    data
    }
};

export const filterByAction = (data) => {
    return {
    type: types.FILTERBY_TOGGLE,
    data
    }
};

export const menuActiveAction = (data) => {
    return {
    type: types.MENU_ACTIVE,
    data
    }
};

export const fromDashboard = (data) => {
    return {
    type: types.FROM_DASHBOARD,
    data
    }
};
export const fromReport = (data) => {
    return {
    type: types.FROM_REPORT,
    data
    }
};

export const fromExpiryCertificates = (data) => {
    return {
    type: types.FROM_EXPIRY_CERTIFICATES,
    data
    }
};

export const fromClientDashboardQuotes = (data) => {
    return {
    type: types.FROM_CLIENT_DASHBOARD_QUOTES,
    data
    }
};

export const fromClientDashboardEvents = (data) => {
    return {
    type: types.FROM_CLIENT_DASHBOARD_EVENTS,
    data
    }
};

export const fromDashboardShiftTimeChange = (data) => {
    return {
    type: types.FROM_DASHBOARD_SHIFT_TIME_CHANGE,
    data
    }
};

export const fromClientDashboardCompletedEvents = (data) => {
    return {
    type: types.FROM_CLIENT_DASHBOARD_COMPLETED_EVENTS,
    data
    }
};

export const fromActionRequired = (data) => {
    return {
    type: types.FROM_ACTION_REQUIRED,
    data
    }
};

export const shiftTitle = (data) => {
    return {
    type: types.SHIFT_TITLE,
    data
    }
};

export const feedbackTitle = (data) => {
    return {
    type: types.FEEDBACK_TITLE,
    data
    }
};

export const crewListTitle = (data) =>{
    return {
    type: types.CREW_LIST_TITLE,
    data
    }
}

export const menuDeactiveAction = (data) => {
    return {
    type: types.MENU_DEACTIVE,
    data
    }
};

export const aflt_skillSelListAction = (data) => {
    return {
    type: types.SKILL_SEL_LIST_AFFILIATE,
    data
    }
};

export const aflt_keyLocationListAction = (data) => {
    return {
    type: types.KEY_LOC_LIST_AFFILIATE,
    data
    }
}; 

export const changePasswordAction = (data) =>{
    return {
        type: types.CHANGE_PASSWORD,
        data
    }
}

export const resendEmailAction = (data) =>{
    return {
        type: types.RESEND_EMAIL,
        data
    }
}

export const profileRoleGetAction = (data) =>{
    return {
        type: types.PROFILE_ROLE,
        data
    }
}

// export const googleLocationSearchAction = (data) =>{
//     return {
//         type: types.GOOGLE_LOCATION_SEARCH,
//         data
//     }
// }

export const countryListAction = (data) =>{
    return {
        type: types.COUNTRY_LIST,
        data
    }
}

export const timeZonesListAction = (data) =>{
    return {
        type: types.TIMEZONES_LIST,
        data
    }
}

export const serverTimeAction = (data) =>{
    return {
        type: types.SERVER_TIME_LIST,
        data
    }
}

export const assocUserActiveAction = (data) => {
    return {
    type: types.ASSOC_USER_ACTIVE,
    data
    }
};

export const assocUserDeactiveAction = (data) => {
    return {
    type: types.ASSOC_USER_DEACTIVE,
    data
    }
};

export const inviteAsFriendAction = (data) => {
    return {
    type: types.INVITE_AS_FRIEND,
    data
    }
};

export const loginAsAction = (data) => {
    return {
    type: types.LOGIN_AS_SET_DATA,
    data
    }
};

export const loginAsUserAction = (data) => {
    return {
    type: types.LOGIN_AS_USER,
    data
    }
};

export const timeSheetDateHeader = (data) => {
    return {
    type: types.TIMESHEET_DATE_HEADER,
    data
    }
};
